<nav class="navbar navbar-expand-lg navbar-custom sticky sticky-dark" role="navigation" aria-label="Navegación principal">
  <div class="container">
    <!-- Logo/Brand -->
    <a class="navbar-brand" routerLink="/" aria-label="Inicio">
      <img src="assets/images/IncluTec.png" alt="Logo" class="logo-img" />
    </a>

    <!-- Toggle button for mobile -->
    <button 
      class="navbar-toggler" 
      type="button" 
      (click)="toggleMobileMenu()"
      [attr.aria-expanded]="isMobileMenuOpen"
      aria-controls="navbarNav" 
      aria-label="Alternar navegación">
      <span class="navbar-toggler-icon"></span>
    </button>

    <!-- Navigation menu -->
    <div class="collapse navbar-collapse" [class.show]="isMobileMenuOpen" id="navbarNav">
      <ul class="navbar-nav ml-auto" role="menubar">
        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-home" aria-hidden="true"></i>
            <span>Inicio</span>
          </a>
        </li>
        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/nosotros" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-users" aria-hidden="true"></i>
            <span>Nosotros</span>
          </a>
        </li>
        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/servicios-empresas" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-cogs" aria-hidden="true"></i>
            <span>Servicios</span>
          </a>
        </li>
        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/oportunidades" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-briefcase" aria-hidden="true"></i>
            <span>Oportunidades</span>
          </a>
        </li>

        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/cumplimiento-ley" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-gavel" aria-hidden="true"></i>
            <span>Ley2466</span>
          </a>
        </li>
        <li class="nav-item" role="none">
          <a class="nav-link" routerLink="/contacto" routerLinkActive="active" role="menuitem" (click)="closeMobileMenu()">
            <i class="fas fa-envelope" aria-hidden="true"></i>
            <span>Contacto</span>
          </a>
        </li>
      </ul>

      <!-- Action buttons -->
      <div class="navbar-nav ml-auto" role="group" aria-label="Acciones de usuario">
        <!-- Botón de login oculto temporalmente - no se usará por ahora -->
        <!--
        <a class="btn btn-custom btn-rounded" routerLink="/login" role="button" aria-label="Iniciar sesión">
          <i class="fas fa-sign-in-alt" aria-hidden="true"></i>
          <span>Iniciar Sesión</span>
        </a>
        -->
        <a class="btn btn-custom btn-rounded" routerLink="/para-candidatos" role="button" aria-label="Registrarse">
          <i class="fas fa-user-plus" aria-hidden="true"></i>
          <span>Registrarse</span>
        </a>
      </div>
    </div>
  </div>
</nav>